<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-实名制管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="营业执照审核" name="list"></el-tab-pane>
    </el-tabs>
    <List v-if="activeName == 'list'"></List>
  </div>
</template>
<script>
import List from "./part/list";

export default {
  components: {
    List
  },
  data() {
    return {
      activeName: "list"
    };
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/technician/business/index.vue